import React, {Component, Fragment} from "react";
/*
    Importing React Router library for routing of each page
*/
import { Router, Switch, Route, Redirect} from "react-router-dom";
import history from './routes/history';
/*
    Importing React Transition Group library for fading in of each page
*/
import { TransitionGroup, CSSTransition } from "react-transition-group";

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
/*
    Importing ScrollToTop component for scroll restoration of the page
    from React Router Guides - Scroll Restoration
*/
import ScrollToTop from './utils/ScrollToTop';

import Welcome from './components/views/Welcome';
import CreateAccount from './components/views/CreateAccount';
import PhoneVerification from './components/views/PhoneVerification';
import AlmostDone from './components/views/AlmostDone';

import StartApplication from './components/views/StartApplication';
import CreatePassword from './components/views/CreatePassword';
import Login from './components/views/Login';
import PersonalInfo from './components/views/PersonalInfo';
import AddressInfo from './components/views/AddressInfo';
import LivingSituation from './components/views/LivingSituation';
import EmploymentInfo from './components/views/EmploymentInfo';
import PaymentSchedule from './components/views/PaymentSchedule';
import BankingInfo from './components/views/BankingInfo';
import AllDone from './components/views/AllDone';
import Reject from './components/views/Reject';
import RejectState from './components/views/RejectState';
import Dashboard from './components/views/Dashboard';

//import Splash from './components/views/Splash';
/*
    Importing Loadable library for Code-Splitting capabilities
*/
import Loadable from 'react-loadable';
/*
    Loadable requires a loading param
    This is a simple example from the Loadable documentation
*/
const Loading = ({isLoading, error}) => {
  if (isLoading) { // Handle the loading state
    return (
      <Fragment>
        <div className="row text-center"><img src="/images/logo/logo.png" className="loadinglogo" alt="MoneyKey Logo" style={{width:'40%',marginTop:'150px'}}/></div>
        <div className="row text-center"><img src="/images/loaders/rotatingloader.gif" className="rotatingloader" alt="Rotating Dots Loader" style={{width:'35%'}}/></div>
      </Fragment>
    );
  } else if (error) { // Handle the error state
    return <div>There was a problem loading the page.</div>;
  } else {
    return null;
  }
};
/*
    Using Loadable for Code-Splitting capability here
    Note: Components should always be capitalized
*/
const Congrats = Loadable({
  loader: () => import("./components/views/Congrats"),
  loading: Loading
});
const PreApproved = Loadable({
  loader: () => import("./components/views/PreApproved"),
  loading: Loading
});
const LoanDocs = Loadable({
  loader: () => import("./components/views/LoanDocs"),
  loading: Loading
});

/*
    App component created from create-react-app
    Returning all routing functionality here
    Uses the ScrollToTop component for scrolling back to the top on route change
    Uses the TransitionGroup & CSSTransition components for animation
    When using the render method (instaed of component) in a Route
    if you also want to pass the Route params (ie: match,history,location)
    you'll need to remember to include them manually
*/
class App extends Component {
  render() {
    return (
      <Router history={history} basename="/newflow" >
        <ScrollToTop>

        <MuiThemeProvider>
          <Route
            render={({ location }) => (
              <Fragment>
                <Route exact path="/" render={() => <Redirect to="/startapplication" />} />
                <TransitionGroup>
                  <CSSTransition key={location.key} classNames="fade" timeout={300}>
                  <Switch location={location}>
                    <Route exact path="/welcome" component={Welcome} />
                    <Route exact path="/startapplication" component={StartApplication} />

                    <Route exact path="/createaccount" component={CreateAccount} />
                    <Route exact path="/createpassword" component={CreatePassword} />

                    <Route exact path="/reachingyou" component={PhoneVerification} />
                    <Route exact path="/personalinfo" component={PersonalInfo} />
                    <Route exact path="/addressinfo" component={AddressInfo} />
                    <Route exact path="/livingsituation" component={LivingSituation} />

                    <Route exact path="/employmentinfo" component={EmploymentInfo} />
                    <Route exact path="/payschedule" component={PaymentSchedule} />
                    <Route exact path="/bankinginfo" component={BankingInfo} />

                    <Route exact path="/congrats/:s" component={PreApproved}/>
                    <Route exact path="/preapproved" component={Congrats}/>

                    <Route exact path="/agreement:s" component={LoanDocs}/>
                    <Route exact path="/loandoc:s" component={LoanDocs}/>

                    <Route exact path="/finalstep" component={AlmostDone} />
                    <Route exact path="/laststep" component={AllDone} />
                    <Route exact path="/notapproved" component={Reject} />
                    <Route exact path="/noservice" component={RejectState} />

                    <Route exact path="/dashboard" render={() => <Redirect to="/dashboard/myaccount" />}/>
                    <Route exact path="/dashboard/:pg" component={Dashboard} />

                    <Route exact path="/login" component={Login} />
                    <Route exact path="/logout" component={AllDone} />
                    <Route render={() => <div>Not Found</div>} />
                  </Switch>
                </CSSTransition>
              </TransitionGroup>
              </Fragment>
            )}
          />

        </MuiThemeProvider>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js